// extracted by mini-css-extract-plugin
export default {"popularArea":"styles_popularArea__9qkGh","active":"styles_active__GHY1z","brandList":"styles_brandList__i8ula","contents":"styles_contents__8PPE4","fadeIn":"styles_fadeIn__vpUp9"};